import React from "react";
import { useHistory } from "react-router-dom";

import { BASE_ASSETS_URL } from "constants/app";
import { LOB } from "constants/common";

import { isMobile } from "utils/deviceType";
import { trackAnalytics } from "services/analytics";
import { trackMOEEvent } from "utils/analytics";
import { navigateHandler } from "utils/redirection";
import { generateUrl } from "utils/generateUrl";
import { isGuestUser } from "utils/guestUtils";

import Environment from "services/environment";

import { LINK_TO_ROUTE, LIB_CONSUMER } from "constants/common";

import { DROPDOWNS, MOE_HEADER } from "../constants";

import styles from "../postLoginHeader.scss";

const env = Environment.getEnv();

const HELP_ITEM = [
  {
    imageUrl: "",
    title: "Getting started",
    description: "Watch our onboarding videos to learn more",
    redirecturl: LINK_TO_ROUTE.GETTING_STARTING,
  },
  {
    imageUrl: "",
    title: "Get Help",
    description: "Visit our repository of resources to get help with your queries",
    redirecturl: LINK_TO_ROUTE.HELP,
  },
];

export default function Help({ source, activeDropdown, setActiveDropdown, isInternalUser, showProductTour }) {
  const history = useHistory();
  const guestUser = isGuestUser();

  const faOnLinkClick = (name) => {
    trackAnalytics({
      eVar9: `b2b|aeh|help|${name.toLowerCase()}`,
    });
  };

  const handleProductTourClick = () => {
    faOnLinkClick("Product Tour");
    showProductTour();
    trackMOEEvent(`${MOE_HEADER}_${DROPDOWNS.HELP}_PRODUCT_TOUR_CLICK`);
  };

  const onHelpItemClick = (e, title, path) => {
    e.preventDefault();
    faOnLinkClick(title);
    trackMOEEvent(`${MOE_HEADER}_${DROPDOWNS.HELP}_${title.toUpperCase().replace(/ /g, "_")}_CLICK`).finally(() =>
      navigateHandler({ history, source, path }),
    );
  };

  return (
    <li
      onClick={() => setActiveDropdown(DROPDOWNS.HELP)}
      className={`${styles.drop_down} ${activeDropdown === DROPDOWNS.HELP ? styles.active : ""} b2b-lib-help`}
    >
      <span className={`${activeDropdown === DROPDOWNS.HELP ? styles.active_icon : styles.inactive_icon}`}>
        <i className="aeh-icon-help-outline"></i>
      </span>
      <div className={styles.dropbox}>
        <div className={`${styles.dropdown_card} ${styles.help_card}`}>
          <div className={styles.card_header}>
            <div className={styles.header_content}>{/* <h5>Help Center</h5> */}</div>
            <div className={styles.close_icon}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
          <div className={styles.card_content}>
            <div className={styles.scroll_content}>
              <ul className={styles.help_list}>
                {HELP_ITEM.map(({ imageUrl, title, description, redirecturl }) => (
                  <li key={title}>
                    <a role="button" onClick={(e) => onHelpItemClick(e, title, redirecturl)}>
                      {/* <div className={styles.help_icon}>
                        <img src={`${BASE_ASSETS_URL}${imageUrl}`} alt="?" />
                      </div> */}
                      <div className={styles.help_content}>
                        <h6>
                          {title}
                          <span className={styles.arrowright}>
                            {/* <img src={`${BASE_ASSETS_URL}images/right-arrow.svg`} /> */}
                          </span>
                        </h6>
                        <p>{description}</p>
                      </div>
                    </a>
                  </li>
                ))}

                {!isMobile() && !guestUser && !isInternalUser && (
                  <li onClick={handleProductTourClick} key="Product Tour">
                    <div className={styles.help_content}>
                      <h6>
                        Product Tour
                        <span className={styles.arrowright}></span>
                      </h6>
                      <p>Take a tour on Airtel Thanks for Business</p>
                    </div>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </li>
  );
}
